<template>
  <div :style="{ backgroundColor: micrositeColor }" class="flexpers">
    <v-container class="credential-container">
      <div class="credential-wrapper">
        <v-btn
          color="#fff"
          v-if="backId !== ''"
          text
          class="credential-back-button px-2"
          :to="{
            path: `/micrositio-membership/${backId}`,
            query: { step: 'members' },
          }"
        >
          <v-icon left>mdi-arrow-left</v-icon> Volver
        </v-btn>
        <v-card rounded="xl" class="credential-card" elevation="2">
          <v-row class="my-auto" style="background: #fff">
            <v-col cols="12" class="credential-content rounded-xl">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-btn
                    style="float: left"
                    :color="
                      homologateStatusWithColor(credentialData.validationStatus).color
                    "
                    width="auto"
                    :loading="load"
                    class="font-weight-black mx-auto text-capitalize font-weight-bold rounded-pill"
                  >
                    {{
                      homologateStatusWithColor(credentialData.validationStatus)
                        .status
                    }}
                  </v-btn>
                </v-col>
                <v-col cols="12" class="pt-0 pb-4 text-center">
                  <v-avatar color="#fbb406" size="100" class="mx-auto mt-4">
                    <span v-if="!avatarImage"
                      style="color: white; font-weight: bold; font-size: 20px"
                      >{{ profileInitials }}</span
                    >
                    <v-img v-else :src="avatarImage"></v-img>
                  </v-avatar>
                  <v-card-title
                    class="px-0 py-1 align-center justify-center"
                    style="
                      font-size: 1.2rem;
                      word-break: break-word;
                      font-weight: 600;
                    "
                    >{{ displayName }}</v-card-title
                  >
                  <!-- <div class="px-0 upercase py-1"> {{ credentialData.branch.company || "N/D" }}  {{ cred.company }}</div>
                  <div class="pb-3"> <span class="px-0 font-weight-black upercase "> MIEMBRO DESDE</span> - {{getbyFindIndex(asociado,'Miembro desde')}}</div> -->
                  <hr class="hr_color mt-5" />
                </v-col>
                <v-col cols="12">
                  <div class="directory-row">
                    <v-icon color="black" class="directory-row__icon">{{
                      isCompanyOrganization ? "mdi-account" : "mdi-domain"
                    }}</v-icon>
                    <span class="directory-row__value">{{ secondaryName }}</span>
                  </div>
                  <div class="directory-row">
                    <v-img
                      src="@/assets/images/landing/memberLanding/ico-telefono.svg"
                      max-width="25"
                      contain
                      class="directory-row__icon"
                    />
                    <span class="directory-row__value">{{ directoryData.phone || "N/D" }}</span>
                  </div>
                  <div class="directory-row">
                    <v-img
                      src="@/assets/images/landing/memberLanding/ico-email.svg"
                      max-width="25"
                      contain
                      class="directory-row__icon"
                    />
                    <span class="directory-row__value">{{ directoryData.email || "N/D" }}</span>
                  </div>

                  <div class="directory-row">
                    <v-icon color="black" class="directory-row__icon">
                      mdi-link-variant
                    </v-icon>
                    <span class="directory-row__value">
                      <a
                        v-if="directoryData.url && directoryData.url !== 'N/D'"
                        :href="formatUrl(directoryData.url)"
                        target="_blank"
                        rel="noopener noreferrer"
                        style="color: inherit; text-decoration: underline"
                      >
                        {{ directoryData.url }}
                      </a>
                      <span v-else>N/D</span>
                    </span>
                  </div>

                  <div v-if="directoryDescription" class="directory-description">
                    <div class="directory-description__label">Descripción de la empresa</div>
                    <p class="directory-description__text">{{ directoryDescription }}</p>
                  </div>
                </v-col>
              </v-row>

              <hr class="hr_color mt-5" />

              <div class="association-section text-center">
                <div class="font-weight-black upercase mb-3">MIEMBRO DE</div>
                <v-avatar size="100" class="hr_color">
                  <span
                    v-if="!organizationImage"
                    style="color: white; font-weight: bold; font-size: 20px"
                    >{{ profileInitials }}</span
                  >
                  <v-img
                    v-else
                    :src="organizationImage"
                  ></v-img>
                </v-avatar>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { homologateStatusWithColor } from "@/common/hook/useHelper.js";

export default {
  data() {
    return {
      micrositeColor: "#00946b",
      affiliationId: "",
      credentialData: {},
      personalInfo: [],
      directions: [],
      asociado: [],
      profile: "",
      backId: "",
      load: false,
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    directoryData() {
      return this.credentialData?.directoryData || {};
    },
    isCompanyOrganization() {
      return this.credentialData?.headOffice?.memberType === "COMPANYS";
    },
    displayName() {
      const directoryName = this.directoryData.name;
      const directoryCompany = this.directoryData.company;
      const memberName = [
        this.credentialData?.name,
        this.credentialData?.firstLastname,
        this.credentialData?.secondLastname,
      ]
        .filter(Boolean)
        .join(" ")
        .trim();

      if (this.isCompanyOrganization) {
        return directoryCompany || this.credentialData?.company || memberName || "N/D";
      }

      return directoryName || memberName || directoryCompany || "N/D";
    },
    secondaryName() {
      if (this.isCompanyOrganization) {
        return this.directoryData.name || this.credentialData?.name || "N/D";
      }

      return this.directoryData.company || this.credentialData?.company || "N/D";
    },
    directoryDescription() {
      return typeof this.directoryData.description === "string"
        ? this.directoryData.description.trim()
        : "";
    },
    avatarImage() {
      const directoryLogo = this.directoryData.logo;
      if (directoryLogo && directoryLogo !== "NOT_ASSIGNED") return directoryLogo;

      const profilePicture = this.credentialData?.profilePicture;
      return profilePicture && profilePicture !== "NOT_ASSIGNED"
        ? profilePicture
        : "";
    },
    organizationImage() {
      const image = this.credentialData?.headOffice?.profilePicture;
      return image && image !== "NOT_ASSIGNED" ? image : "";
    },
    profileInitials() {
      const name = this.displayName || "W";
      return name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join("");
    },
  },
  methods: {
    ...mapActions("microsite", ["getMemberInformation"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    homologateStatusWithColor,
    formatUrl(url) {
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        return "https://" + url; // O usa "http://" si es necesario
      }
      return url;
    },

    async fetchMicrositeConfig() {
      try {
        const response = await this.axios.get(
          `/microsite/affiliation/${this.affiliationId}`
        );
        if (response && response.data) {
          this.micrositeColor =
            response.data.affiliation.micrositeConfiguration.primaryColor;
        } else {
          console.error("Respuesta inesperada de la API", response);
        }
      } catch (error) {
        if (error.response) {
          console.error(
            "Error en la respuesta de la API:",
            error.response.status,
            error.response.data
          );
        } else {
          console.error("Error en la solicitud:", error.message);
        }
      }
    },

    formatUserData(user = null) {
      if (!user) return {};

      const directoryData = {
        titular: false,
        visible: false,
        name: [user.name, user.firstLastname].filter(Boolean).join(" "),
        company: user.company || "N/D",
        description: "",
        phone: user.phone || "N/D",
        email: user.email || "N/D",
        url: user.url || "N/D",
        ...(user.directoryData || {}),
      }

      const result = {
        ...user,
        directoryData,
      }

      return result;
    },

  },
  async mounted() {
    this.loading();
    this.load = true;
    const retrievedUserData = (
      await this.getMemberInformation(this.$route.params.memberId)
    ).data;
    this.credentialData = this.formatUserData(retrievedUserData);
    this.affiliationId = this.user?.affiliation?.national?.details[0]?.affiliationType?.affiliation || this.credentialData?.memberActiveItems[0]?.affiliation;
    await this.fetchMicrositeConfig();

    this.loaded();
    this.load = false;
  },
  created() {
    if (this.$route.query.micrositeId) {
      this.backId = this.$route.query.micrositeId;
    }
  },
};
</script>


<style scoped>
.flexpers {
  display: flex;
  align-items: flex-start;
  box-sizing: border-box;
  overflow-y: auto;
  min-height: 100vh;
  width: 100%;
}
.credential-container {
  box-sizing: border-box;
  width: 100%;
  max-width: 560px !important;
  margin: auto auto !important;
  padding: 24px 16px 36px !important;
}
.credential-wrapper,
.credential-card {
  width: 100%;
}
.credential-back-button {
  margin: 0 0 12px !important;
}
.credential-card {
  overflow: hidden;
}
.v-main__wrap {
  background: aliceblue !important;
}
.hr_color {
  border: 1px solid #c4c6c8;
}
.credential-content {
  background: #f8fafc;
  padding: 28px 24px 24px !important;
}
.directory-row {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  padding: 8px 0;
}
.directory-row__icon {
  flex: 0 0 25px;
  margin-right: 8px;
}
.directory-row__value {
  min-width: 0;
  flex: 1 1 auto;
  overflow-wrap: anywhere;
  word-break: break-word;
  color: #222b4c;
  font-size: 0.95rem;
  line-height: 1.45;
}
.directory-description {
  margin-top: 18px;
  padding: 14px 16px;
  border: 1px solid #e1e5e9;
  border-radius: 12px;
  background: #fff;
}
.directory-description__label {
  margin-bottom: 6px;
  color: #222b4c;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.directory-description__text {
  margin: 0;
  color: #4b5563;
  font-size: 0.94rem;
  line-height: 1.55;
  overflow-wrap: anywhere;
  white-space: pre-line;
}
.association-section {
  padding: 18px 0 8px;
}
.upercase {
  text-transform: uppercase !important;
}

@media screen and (max-width: 380px) {
  .credential-container {
    padding-right: 12px !important;
    padding-left: 12px !important;
  }

  .credential-content {
    padding-right: 18px !important;
    padding-left: 18px !important;
  }
}
</style>
